// Admin API types
export enum DeviceType {
  Smartphone = 0,
  Tablet = 1,
  Laptop = 2,
  Desktop = 3,
  Television = 4,
  StreamingDevice = 5,
  Router = 6,
  Modem = 7,
  SmartSpeaker = 8,
  Printer = 9,
  Camera = 10,
  SmartWatch = 11,
  GamingConsole = 12,
  SmartHome = 13,
  Other = 14
}

export enum SkillLevel {
  Beginner = 0,
  Intermediate = 1,
  Advanced = 2
}

export enum Verbosity {
  Brief = 0,
  Moderate = 1,
  Detailed = 2
}

export interface Device {
  id: string;
  name: string;
  type: DeviceType;
  brand?: string;
  model?: string;
  notes?: string;
  imageUrl?: string;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
}

export interface UserProfile {
  id: string;
  displayName: string;
  email?: string;
  skillLevel: SkillLevel;
  preferredVerbosity: Verbosity;
  monthlyMessageLimit: number;
  messagesUsedThisMonth: number;
  isActive: boolean;
  createdAt: string;
  lastLoginAt?: string;
}

export interface CreateDeviceRequest {
  name: string;
  type: DeviceType;
  brand?: string;
  model?: string;
  notes?: string;
  imageUrl?: string;
}

export interface UpdateDeviceRequest extends CreateDeviceRequest {
  isActive: boolean;
}

export interface UpdateUserProfileRequest {
  displayName: string;
  skillLevel: SkillLevel;
  preferredVerbosity: Verbosity;
  monthlyMessageLimit: number;
  isActive: boolean;
  preferences?: string;
  notes?: string;
  rules?: string;
}

// ============================================================================
// Admin Conversation Types
// ============================================================================

export interface ConversationSummary {
  sessionId: string;
  userId: string;
  userName: string;
  messageCount: number;
  lastMessageAt: string;
  sentimentScore: number | null;
  sentimentClassification: string | null;
  hasNegativeSentiment: boolean;
}

export interface ConversationDetail {
  sessionId: string;
  userId: string;
  userName: string;
  title: string;
  systemPromptTemplateName?: string;
  systemPrompt?: string;
  createdAt: string;
  lastMessageAt: string | null;
  messageCount: number;
  startedAt: string;
  messages: MessageWithSentiment[];
  overallSentiment: OverallSentiment;
}

export interface MessageWithSentiment {
  id: string;
  content: string;
  role: 'user' | 'assistant' | 'system';
  createdAt: string;
  tokensUsed: number | null;
  sentimentScore: number | null;
  sentimentClassification: string | null;
  sentimentKeywords: string[] | null;
  isNegativeFlag: boolean;
  systemPrompt?: string | null;
  systemPromptTemplateName?: string | null;
}

export interface OverallSentiment {
  score: number;
  averageScore: number;
  classification: string;
  trend: SentimentTrendPoint[];
  hasNegativeMessages: boolean;
}

export interface SentimentTrendPoint {
  timestamp: string;
  score: number;
}
